class InstallPluginModalController {
    static $inject = ['close', 'confirm', '$translate'];
    constructor(close, confirm, $translate) {
        'ngInject';
        this.close = close;
        this.confirm = confirm;
        this.$translate = $translate;
        const strengths = this.$translate.instant('builder.smartSales.strengths');
        this.strengths = strengths.split('<br>');
    }
    async _confirm() {
        this.confirm();
        this.close(true);
    }
    async _cancel() {
        this.close(false);
    }
}
InstallPluginModalController.$inject = ['close', 'confirm', '$translate'];
export default InstallPluginModalController;
